import { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import PageLoader from "./components/PageLoader";
import ReduxModalsIndex from "./modals/ReduxModalsIndex";
// import CustomerBankConsent from "./screens/CustomerBankConsent";
import InProgressCustomers from "./screens/InProgressCustomers";
// import LivenessCheck from "./components/LivenessCheck";
import "./styles/bundles.css";
import "./styles/kyc.css";
import ValidateOTP from "./components/ValidateOtp";
// import OnboardedCustomers from "./screens/OnboardedCustomers";
import CustomerDetails from "./screens/CustomerDetails";
import { ToastContainer } from "react-toastify";
import PodcastList from "./screens/PodcastList";
import OxygenFormOTP from "./screens/OxygenFormOTP";
import OxygenLoanOTP from "./screens/OxygenLoanOTP";
import NextOfKinOTP from "./screens/NextOfKinOTP";
import OxygenPaymentLinks from "./screens/OxygenPaymentLinks";
import OxygenDetailsUpdate from "./screens/OxygenDetailsUpdate";
import OxygenAllDevices from "./screens/OxygenAllDevices";
import OxygenDeviceBundles from "./screens/OxygenDeviceBundles";
import OxygenPaymentSchedulePlan from "./screens/OxygenPaymentSchedulePlan";
import OxygenRetail from "./screens/OxygenRetail";
import CombinedLivenesssCheck from "./screens/CombinedLivenesssCheck";
import FBNPrequalForm from "./screens/FBNPrequalForm";
import AODF2FormOTP from "./screens/AODF2FormOTP";
import AODFTandC from "./components/AODFTandC";
import OxygenPaymentConfirmationSucess from "./screens/OxygenPaymentConfirmationSucess";
import FBNPaymentLink from "./screens/FBNPaymentLink";
import OxygenRetailForm2 from "./screens/OxygenRetailForm2";
import ProposedDeviceBundles from "./screens/ProposedDeviceBundles";
import FBNDeviceBundles from "./components/FBNDeviceBundles";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import ExternalTandC from "./screens/ExternalTandC";

const App = () => {
  const Login = lazy(() => import("./screens/Login"));
  const Dashboard = lazy(() => import("./screens/Dashboard"));
  const ProtectedRoutes = lazy(() =>
    import("./components/auth/ProtectedRoutes")
  );
  const Prequalification = lazy(() => import("./screens/Prequalification"));
  const BundlesTandC = lazy(() => import("./screens/BundlesTandC"));
  const Bundles = lazy(() => import("./screens/Bundles"));
  // const AutodebitTandC = lazy(() => import("./screens/AutodebitTandC"));
  const KYC = lazy(() => import("./screens/KYC"));
  const Sideload = lazy(() => import("./screens/Sideload"));
  const DeviceRelease = lazy(() => import("./screens/DeviceRelease"));
  // const FingerPrint = lazy(() => import("./screens/FingerPrint"));
  const OnboardedCustomers = lazy(() => import("./screens/OnboardedCustomers"));

  const token = useSelector(
    (state) => state?.user?.user?.accessTokens?.token?.token
  );

  // console.log(token?.length);

  return (
    <>
      <ReduxModalsIndex />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/oxygen-payment-confirmation" element={<OxygenPaymentConfirmationSucess />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<ExternalTandC />} />
          <Route
            exact
            path="/"
            element={token?.length > 1 ? <Dashboard /> : <Login />}
          />
          <Route element={<ProtectedRoutes path="dashboard" />}>
            <Route path="dashboard" element={<Dashboard />} />
          </Route>
          <Route element={<ProtectedRoutes path="prequalify" />}>
            <Route path="prequalify" element={<Prequalification />} />
          </Route>
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="fbn-prequal-form" element={<FBNPrequalForm />} />
          </Route>
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="validate-otp" element={<ValidateOTP />} />
          </Route>
          {/* <Route element={<ProtectedRoutes path="liveness-check" />}>
            <Route path="/liveness-check" element={<LivenessCheck />} />
          </Route> */}
          <Route element={<ProtectedRoutes path="bundles" />}>
            <Route path="bundles" element={<Bundles />} />
          </Route>
          <Route element={<ProtectedRoutes path="bundletandc" />}>
            <Route path="bundletandc" element={<BundlesTandC />} />
          </Route>
          <Route element={<ProtectedRoutes path="kyc" />}>
            <Route path="kyc" element={<KYC />} />
          </Route>
          
          {/* <Route  element={<ProtectedRoutes path="fingerprint"/>}><Route path="fingerprint" element={<FingerPrint/>} /></Route> */}
          {/* <Route  element={<ProtectedRoutes path="customer-bank-consent"/>}><Route path="customer-bank-consent" element={<CustomerBankConsent/>} /></Route> */}
          {/* <Route  element={<ProtectedRoutes path="autodebittandc"/>}><Route path="autodebittandc" element={<AutodebitTandC />} /></Route> */}
          <Route element={<ProtectedRoutes path="sideload" />}>
            <Route path="sideload" element={<Sideload />} />
          </Route>
          <Route element={<ProtectedRoutes path="deviceRelease" />}>
            <Route path="deviceRelease" element={<DeviceRelease />} />
          </Route>
          <Route element={<ProtectedRoutes path="status/inprogress" />}>
            <Route path="status/inprogress" element={<InProgressCustomers />} />
          </Route>
          <Route element={<ProtectedRoutes path="status/onboarded" />}>
            <Route path="status/onboarded" element={<OnboardedCustomers />} />
          </Route>
          <Route element={<ProtectedRoutes path="customers/:id" />}>
            <Route path="customers/:id" element={<CustomerDetails />} />
          </Route>
          {/* <Route  element={<ProtectedRoutes path="onboarding/activate-bundles"  />}><Route path="onboarding/activate-bundles" element={<CustomerStatus />} /></Route> */}
          <Route path="*" element={<p>There's nothing here: 404!</p>} />
          <Route
            path="/test"
            element={<PodcastList />}
          />
          
          {/* For Oxygen */}
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="/oxygen-devices" element={<OxygenAllDevices />} />
          </Route>
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="/proposed-devices-bundle" element={<ProposedDeviceBundles />} />
          </Route>
          <Route element={<ProtectedRoutes path="oxygen-device-bundles" />}>
            <Route path="/oxygen-device-bundles" element={<OxygenDeviceBundles />} />
          </Route>
          <Route element={<ProtectedRoutes path="oxygen-device-bundles" />}>
            <Route path="/fbn-device-bundles" element={<FBNDeviceBundles />} />
          </Route>
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="/oxygen-details-form" element={<OxygenRetail />} />
          </Route>
          <Route element={<ProtectedRoutes path="" />}>
            <Route path="/oxygen-details-form2" element={<OxygenRetailForm2 />} />
          </Route>
          <Route element={<ProtectedRoutes path="liveness-check" />}>
            <Route path="/oxygen-payment-schedule-plan" element={<OxygenPaymentSchedulePlan />} />
          </Route>
          <Route element={<ProtectedRoutes path="validate-otp-oxygen" />}>
            <Route path="/oxygenForm-OTP" element={<OxygenFormOTP />} />
          </Route>

          <Route element={<ProtectedRoutes path="validate-otp-aodf2" />}>
            <Route path="/aodf2Form-OTP" element={<AODF2FormOTP />} />
          </Route>

          <Route element={<ProtectedRoutes path="" />}>
            <Route path="/aodfTandC" element={<AODFTandC />} />
          </Route>
          
          <Route element={<ProtectedRoutes path="oxygenLoan-OTP" />}>
            <Route path="/oxygenLoan-OTP" element={<OxygenLoanOTP />} />
          </Route>

          <Route element={<ProtectedRoutes path="nextOfKin-OTP" />}>
            <Route path="/nextOfKin-OTP" element={<NextOfKinOTP />} />
          </Route>

          <Route element={<ProtectedRoutes path="oxygenpayment-links" />}>
            <Route path="/oxygenpayment-links" element={<OxygenPaymentLinks />} />
          </Route>

          <Route element={<ProtectedRoutes path="oxygenpayment-links" />}>
            <Route path="/fbnpayment-link" element={<FBNPaymentLink />} />
          </Route>

          <Route element={<ProtectedRoutes path="oxygenDetails-update" />}>
            <Route path="/oxygendetails-update" element={<OxygenDetailsUpdate />} />
          </Route>

          <Route element={<ProtectedRoutes path="liveness-check" />}>
            <Route path="/liveness-check" element={<CombinedLivenesssCheck />} />
          </Route>
        </Routes>

        {/* Toast container  */}
        <ToastContainer />
      </Suspense>
    </>
  );
};

export default App;
